import * as yup from "yup";

const capitalize = (v: string) =>
  v ? v.charAt(0).toUpperCase() + v.slice(1) : v;

export const transforms = {
  ruName: (v: string) => capitalize(v.replace(/\s/g, "")),
  latinUpper: (v: string) =>
    v.replace(/\s/g, "").replace(/[^a-zA-Z]/g, "").toUpperCase(),
  ruAlnumLower: (v: string) =>
    v.replace(/\s/g, "").replace(/[^а-яА-ЯёЁ0-9]/g, "").toLowerCase(),
  digits: (v: string) => v.replace(/\D/g, ""),
  // Показываем номер карты группами по 4 — в форме хранятся только цифры.
  cardGroups: (v: string) => (v.match(/.{1,4}/g) ?? []).join(" "),
  phone: (raw: string) => {
    let digits = raw.replace(/\D/g, "");
    if (digits.startsWith("8") || digits.startsWith("7")) {
      digits = digits.slice(1);
    }
    return "+7" + digits.slice(0, 10);
  },
};

export const registerSchema = yup.object({
  last_name: yup.string().trim().min(2, "Минимум 2 символа").required("Введите фамилию"),
  name: yup.string().trim().min(2, "Минимум 2 символа").required("Введите имя"),
  second_name: yup.string().trim().min(2, "Минимум 2 символа").required("Введите отчество"),
  phone: yup
    .string()
    .matches(/^\+7\d{10}$/, "Формат: +7XXXXXXXXXX (11 цифр)")
    .required("Введите телефон"),
  birthday: yup
    .string()
    .required("Укажите дату рождения")
    .test("age", "Возраст должен быть от 18 до 80 лет", (v) => {
      if (!v) return false;
      const d = new Date(v);
      if (isNaN(d.getTime())) return false;
      const now = new Date();
      let age = now.getFullYear() - d.getFullYear();
      const m = now.getMonth() - d.getMonth();
      if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
      return age >= 18 && age <= 80;
    }),
  city_id: yup.string().required("Выберите филиал"),
  card_number: yup
    .string()
    .matches(/^\d{16}$/, "16 цифр без пробелов")
    .required("Введите номер карты"),
  driver_card_name: yup
    .string()
    .matches(/^[A-Z]+$/, "Латинские буквы")
    .required("Введите имя как на карте"),
  driver_card_surname: yup
    .string()
    .matches(/^[A-Z]+$/, "Латинские буквы")
    .required("Введите фамилию как на карте"),
  car_brand: yup.string().required("Выберите марку"),
  car_model: yup.string().required("Выберите модель"),
  car_color: yup.string().required("Выберите цвет"),
  car_year: yup.string().required("Выберите год выпуска"),
  car_class: yup.string().required("Выберите класс авто"),
  gos_number: yup
    .string()
    .min(5, "Минимум 5 символов")
    .max(9, "Максимум 9 символов")
    .matches(/^[а-яё0-9]+$/, "Только русские буквы и цифры")
    .required("Введите гос. номер"),
});

export type RegisterFormValues = yup.InferType<typeof registerSchema>;
